/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

/**
 * Check-in error properties.
 */
export interface ICheckInErrorProps {
    errorMessage?: string;
}

/**
 * Check-in error.
 * @param errorProps - The error properties.
 * @param errorProps.errorMessage - The error message to show.
 * @returns The alert element showing check-in errors.
 */
export const CheckInErrorComponent: React.FC<ICheckInErrorProps> = ({ errorMessage }) => {
    if (!errorMessage) {
        return null;
    }

    return (
        <span className='msc-alert msc-alert-noborder msc-alert-danger'>
            <span className='msi-exclamation-triangle' aria-hidden='true' />
            <span>{errorMessage}</span>
        </span>
    );
};
